<template>
  <header class="flex flex-row items-center justify-center bg-blue-600 text-white p-4 mb-10">
    <div class="text-3xl md:text-5xl font-bold mb-3">
      <v-icon class="coronavirus-icon" name="md-coronavirus" />&nbsp;Covid-19 Tracker
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
